import RecoverPasswordWithPhoneHeader from '@/features/auth/recover-password-form/recover-with-phone/components/RecoverPasswordWithPhoneHeader'
import { RecoverPasswordWithPhoneForm } from '@/features/auth/recover-password-form/recover-with-phone/components/RecoverPasswordWithPhoneForm'
import { BaseView } from '@/components/base'

export function RecoverPasswordWithPhoneScreen() {
  return (
    <BaseView flex={1} px={12} gap={20} className="h-full">
      <RecoverPasswordWithPhoneHeader />
      <RecoverPasswordWithPhoneForm />
    </BaseView>
  )
}
